import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public password: string = '';
    public loading: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/overview";
    }

    public async login() {
        if (!this.password) {
            await this.service.modal.error("비밀번호를 입력해주세요.");
            return;
        }
        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call("login", { password: this.password });

        this.loading = false;
        await this.service.render();

        if (code == 200) {
            location.href = "/overview";
        } else {
            await this.service.modal.error(data?.message || "비밀번호가 올바르지 않습니다.");
            this.password = '';
            await this.service.render();
        }
    }
}

export default PageAccessComponent;